// extracted by mini-css-extract-plugin
export default {"disabledButton":"style_disabledButton__5N3lq"};